import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import {CircularProgress} from "@mui/material";
import {useAuth} from "./hooks/useAuth";
import Login from "./components/Auth/Login/Login";
import SignUp from "./components/Auth/SignUp/SignUp";
import ForgotPassword from "./components/Auth/ForgotPassword/ForgotPassword";
import {Toaster} from "./components/shared/Toaster/Toaster";
import Layout from "./components/Layout/Layout";
import {routeConfigs} from "./navigation/routeConfig";
import AuthLayout from "./components/Layout/AuthLayout/AuthLayout";

import './app.css';
const App:React.FunctionComponent = () => {
  const { isLoading, isAuthenticated } = useAuth();  

  if (isLoading) {
    return <CircularProgress sx={{position: 'absolute', left: '50%', top: '50%'}} color="inherit" />
  }

  if (isAuthenticated) {
    return (
      <Layout />
    )
  }

  return (
    <AuthLayout>
      <Toaster>
        <BrowserRouter>
          <Routes>
            <Route path={routeConfigs.signUp.path} element={<SignUp />} />
            <Route path={routeConfigs.forgotPassword.path} element={<ForgotPassword />} />
            <Route path={routeConfigs.login.path} element={<Login />} />
            <Route path={routeConfigs.buy.path} element={ <Navigate to={routeConfigs.login.path} /> } />
            <Route path="*" element={ <Navigate to={routeConfigs.login.path} /> } />
          </Routes>
        </BrowserRouter>
      </Toaster>
    </AuthLayout>
  );
}

export default App;
